import React from "react";
import HliAdminLoanView from "../components/HliAdminLoanView";
import AutoLogout from "./AutoLogout";

export default function HliAdminAutoLogout() {
  return (
    <AutoLogout>
      <HliAdminLoanView />
    </AutoLogout>
  );
}
